import * as React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const Seo = ({ title, description, keywords, lang, meta }) => {

  let siteTitle = 'Escuela de Posgrado UCC'
  let siteDesc= 'Universidad Católica de Córdoba - Escuela de Posgrado'
  let siteKeywords = 'Universidad Católica de Córdoba, UCC - Posgrado'
  let author = 'Universidad Católica de Córdoba'

  const preventIndex = 'index, follow'
  const defaultTitle = title ? title : siteTitle
  const defaultDescription = description ? description : siteDesc
  const defaultKeywords = keywords ? keywords : siteKeywords

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={defaultTitle}
      titleTemplate={defaultTitle ? `${defaultTitle} | UCC` : null}
      meta={[
        {
          name: 'robots',
          content: preventIndex,
        },
        {
          name: 'description',
          content: defaultDescription,
        },
        {
          name: 'keywords',
          content: defaultKeywords,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: defaultDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: author || '',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: defaultDescription,
        },
      ].concat(meta)}
    />
  )
}

Seo.defaultProps = {
  lang: 'es',
  meta: [],
  description: '',
}

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
}

export default Seo